<template>
  <div id="game-wrapper" :class="{start: bStartScreen}" @click="bStartScreen = false" @touchstart.self.prevent="bStartScreen = false">
    <div id="object">
      <img src="../src/assets/kirche.png" alt="" />
      <p><span>© bpk / Scala</span></p>
      </div>
    <img id="title" src="../src/assets/title.jpg" alt="" />
    <div id="question">
      <h1>
        <span>
          {{question.text}}
        </span>
      </h1>
      <ul>
        <li v-for="answer in question.answers" :key="answer.id" :data-answer-id="answer.id" @click="onAnswerClick(answer.id)" @touchstart.self.prevent="onAnswerClick(answer.id)" :class="{current: (answer.id == selectedAnswerId)}">
          <span>{{ answer.text }}</span>
        </li>
      </ul>
    </div>
    <div>
      <div :class="{popup: true, show: (answer.id == selectedAnswerId)}" v-for="answer in question.answers" :key="answer.id" @click="selectedAnswerId = 0" @touchstart.self.prevent="selectedAnswerId = 0" v-html="answer.popup"></div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'Multiple-Choice',
  data () {
    return {
      bStartScreen: true,
      selectedAnswerId: 0,
      question: {
        text: 'Wo wurde diese Kirche gebaut? ',
        answers: [
          {
            id: 1,
            text: 'in Rom',
            popup: '<h2>Richtig!</h2> <p>Die Kirche steht in Rom und wurde der heiligen Maria geweiht. Deshalb heißt sie auf italienisch: Santa Maria Maggiore. </p><p>Hättest du diese Kirche auf dem Gemälde wiedererkannt?</p>'
          },
          {
            id: 2,
            text: 'in Madrid',
            popup: '<h2>Leider falsch.</h2>'
          },
          {
            id: 3,
            text: 'in Paris',
            popup: '<h2>Leider falsch.</h2>'
          }
        ]
      }
    }
  },
  created () {
  },
  methods: {
    onAnswerClick (id) {
      console.log('onAnswerClick()', id)
      this.selectedAnswerId = id
    }
  }
}
</script>
